import { type BreadcrumbItem, Breadcrumbs as UIBreadcrumbs } from '@/components/ui/breadcrumbs';
import styles from './Breadcrumbs.module.css';

interface BreadcrumbsProps {
  links: {
    name: string;
    href: string;
  }[];
}

// Legacy wrapper - converts old format to new format
export default function Breadcrumbs({ links }: BreadcrumbsProps) {
  const items: BreadcrumbItem[] = links.map((link) => ({
    label: link.name,
    href: link.href,
  }));

  return (
    <div className={styles.breadcrumbs}>
      <UIBreadcrumbs items={items} />
    </div>
  );
}
